import {useBombeoMap} from "saneamiento/bombeo/hooks";
import {FormMapGeojsonPoint} from "base/component/form";
import {useOutletContext} from "react-router-dom";

const BombeoFormLocationFields = ({isCreationForm = false}) => {
    let concello;
    [concello] = useOutletContext();

    const {mapConfig} = useBombeoMap(isCreationForm ? concello : null);

    return (
        <FormMapGeojsonPoint
            name="geom"
            mapConfig={mapConfig}
            rules={{required: "O campo é obrigatorio"}}
        />
    );
};

export default BombeoFormLocationFields;
